<mat-slider #slider class="range-slider__mat-slider" [step]="step" [min]="config.min" [max]="config.max"
	[disabled]="disabled" disableRipple="true">
	<input (valueChange)="updateMinValue($event)" #min matSliderStartThumb>
	<input (valueChange)="updateMaxValue($event)" #max matSliderEndThumb>
</mat-slider>
<div class="minmax">
	<div class="box card-background-color border-color range-slider__min-max-value">
		<span>{{min.value}}</span>
	</div>
	<div *ngIf="currentValue" class="box card-background-color border-color range-slider__current-value">
		<span>{{currentValue}}</span>
	</div>
	<div class="box card-background-color border-color range-slider__min-max-value">
		<span>{{max.value}}</span>
	</div>
</div>